import ActionType from "./ActionType";
import {ContactPostModel} from "../../model/ContactModel";
import {createAsyncAction} from "typesafe-actions";

export const postContact = createAsyncAction(
  ActionType.POST_CONTACT_REQUEST,
  ActionType.POST_CONTACT_SUCCEEDED,
  ActionType.POST_CONTACT_FAILED
)<ContactPostModel, void, Error>();
